import React from 'react';
import styled from 'styled-components';

import { CommonFaqProps } from '@front/common/src/types/components';

import Accordion from '../accordion/accordion';
import Title from '../base-text/variants/title';
import WithSeparators from '../separator/with-separators';
import SanitizedHTML from '../sanitized-html/sanitized-html';
import { textStyle, TextStyleProps } from '../base-text/base-text';

export type FaqProps = CommonFaqProps & {
  className?: string;
};

const SeparatorsContainer = styled(WithSeparators)`
  margin: 20px 0;
`;

const StyledTitle = styled(Title.MD)`
  display: flex;
  margin-bottom: 30px;
`;

const HTMLText = styled(SanitizedHTML)<TextStyleProps>`
  ${textStyle};
`;

const Faq = ({ title: mainTitle, questions, className, ...accordionProps }: FaqProps) => (
  <div className={className}>
    <StyledTitle>{mainTitle}</StyledTitle>
    <SeparatorsContainer>
      {questions.map(({ content, title }) => (
        <Accordion key={title} titleSize='MD' title={title} {...accordionProps}>
          <HTMLText html={content.replace(/(?:\r\n|\r|\n)/g, '<br>')} />
        </Accordion>
      ))}
    </SeparatorsContainer>
  </div>
);

export default Faq;
